import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import VisitorCustoomerArea from '../../../components/visitor'
import './style.scss'
const VisitorCustoomerAreaPage = () => {

    return (
        <Fragment>
            
           <VisitorCustoomerArea
           className="SignInArea"
            />
         {/*    <FooterArea/> */}
        </Fragment>
    )
}
export default VisitorCustoomerAreaPage
/* VisitorCustoomerArea */